/** A fresh id for a log step, unique across entities and types. */
export const newOptionId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `evt-${Date.now()}-${Math.round(Math.random() * 1e6)}`;
